import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { inject, observer } from "mobx-react";
import * as mobx from 'mobx'
import green from '@material-ui/core/colors/green';
import Paper from '@material-ui/core/Paper';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Favorite from '@material-ui/icons/Favorite';
import FavoriteBorder from '@material-ui/icons/FavoriteBorder';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';

function jsUcfirst(string) 
{
    return string.charAt(0).toUpperCase() + string.slice(1);
}

const styles = theme => ({
  paper: {
    width:'100%',
    minHeight: 200,
    padding: theme.spacing.unit * 2,
    textAlign:'left'
  },
  priceCard:{
    marginBottom: theme.spacing.unit * 2,
    backgroundColor:'black'
  },
  description:{
    color:'#45A29E'
  },
  toolTips:{
    color: '#FFFFFF',
    backgroundColor: '#000000',
    border: '1px solid #45A29E',
    //opacity: 1,
  },
});

@inject("commonStore")
@observer
class PriceLevels extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }
  makeLabel = (value) => {
    const splitArray = value.split('_')
    if(splitArray.length > 1){
      return `${jsUcfirst(splitArray[0])} ${jsUcfirst(splitArray[1])}`
    }
    return jsUcfirst(value)
}
  getCurrent = (name) => {
    const { filters, leadType, qualifier, contact } = this.props
    const filterArray = filters[leadType]['qualifiers'][qualifier][contact]
    const updateFilterArray = filterArray.filter((item) => {
          return item.field === name
    })
    let conditionPriceLevels = []
    if(updateFilterArray.length > 0){
      conditionPriceLevels = updateFilterArray[0].include
    }

    return conditionPriceLevels

  }
  selectAllUpdate = (condition) => {
    const { leadType, qualifier, contact, filters, updateFilters } = this.props
    const newFilters = {...filters}
    const { commonStore } = this.props
    const { network } = commonStore
    const { priceMaps } = network
    const { carte } = priceMaps

    const levels = carte[leadType][qualifier][contact][condition]
    const povertyLevels = Object.keys(levels)

      const include = []

       const foundFilterArray = filters[leadType]['qualifiers'][qualifier][contact].filter((item) => {
        return item.field === 'condition:povertyLevel'
       })

       const includes = foundFilterArray.length > 0 ? foundFilterArray[0].include : []
       const selectedArray = includes.filter((item) => {
         return item.includes(condition)
       })

       const notselectedArray = includes.filter((item) => {
        return !item.includes(condition)
      })
   
       if(foundFilterArray.length > 0){
          if(selectedArray.length < 1){
            for(let povertyLevel of povertyLevels){
              include.push(`${condition}:${povertyLevel}`)
            }
        
          }else{
  
          }

          const newFilterArray = filters[leadType]['qualifiers'][qualifier][contact].filter((item) => {
            return item.field !== 'condition:povertyLevel'
          })


          newFilterArray.push({
            "field": "condition:povertyLevel",include: [...include, ...notselectedArray]
          })
        
          newFilters[leadType]['qualifiers'][qualifier][contact] = newFilterArray
      
        }else{
          const newFilterArray = filters[leadType]['qualifiers'][qualifier][contact].filter((item) => {
            return item.field !== 'condition:povertyLevel'
          })
          for(let povertyLevel of povertyLevels){
            include.push(`${condition}:${povertyLevel}`)
          }


          newFilters[leadType]['qualifiers'][qualifier][contact].push({
            "field": "condition:povertyLevel", include: [...include, ...notselectedArray]
          })
       }
    

    updateFilters(newFilters)

  }
  update = (value) => {
    const { leadType, qualifier, contact, filters, updateFilters } = this.props
    const filterArray = filters[leadType]['qualifiers'][qualifier][contact]

    let updated = false
    const updateFilterArray = filterArray.map((item) => {
        if(item.field === 'condition:povertyLevel'){
          updated = true
          const index = item.include.indexOf(value)
          let { include } = item
      
          if(index > -1){
            include = include.filter((item) => {
              return value !== item
            })
          
          }else{
            include.push(value)
     
          }
          item.include = [...include]
        }
       return item
    })
    const newFilters = {...filters}

    if(!updated){
      newFilters[leadType]['qualifiers'][qualifier][contact].push({
        "field": "condition:povertyLevel",
        "include": [value],
      })
    }else{
      newFilters[leadType]['qualifiers'][qualifier][contact] = updateFilterArray
    }

    updateFilters(newFilters)
    
  }


  makePriceRowItems = (condition) => {
    const { priceLevelsAllowed, commonStore, leadType, qualifier, contact } = this.props
    const { network } = commonStore
    const { priceMaps } = network
    const { carte } = priceMaps
    const conditions = this.getCurrent('condition:povertyLevel')
    const levels = carte[leadType][qualifier][contact][condition]
    const povertyLevels = Object.keys(levels)
       
    return povertyLevels.map(povertyLevel => {
            const level = levels[povertyLevel]
            const { price, discount } = level

            return (
                    <FormControlLabel
                    key={`${condition}${povertyLevel}`}
                    control={
                        <Checkbox
                        checked={conditions.includes(`${condition}:${povertyLevel}`)}
                        onChange={() => this.update(`${condition}:${povertyLevel}`)}
                        value={`${condition}:${povertyLevel}`}
                        color="primary"
                        />
                    }
                    label={`Level ${povertyLevel}: $${(price / 100).toFixed(2)} ${discount > 0 ? `$${discount} ` : ''}`}
                    //label={`${price / 100}`}
                    />
          
            )

    })
  }
  makeConditionRows = () => {

    const { classes, priceLevelsAllowed, filters, leadType, qualifier, contact } = this.props

    const conditions = this.getCurrent('condition')

    if(conditions.length < 1){
      return <Typography style={{marginTop: 20}} variant="h6"> Please select a condition above...</Typography>
    }

    return conditions.map((condition) => {
     
       const levels = this.makePriceRowItems(condition)
 
         const foundFilterArray = filters[leadType]['qualifiers'][qualifier][contact].filter((item) => {
          return item.field === 'condition:povertyLevel'
         })

         const includes = foundFilterArray.length > 0 ? foundFilterArray[0].include : []

         const selectedArray = includes.filter((item) => {
           return item.includes(condition)
         })

          levels.unshift( <FormControlLabel
            key={`${condition}selectall`}
            control={
                <Checkbox
                checked={priceLevelsAllowed.length === selectedArray.length}
                onChange={() => this.selectAllUpdate(condition)}
                value={'selectall'}
                color="primary"
                />
            }
            label={`Select All`}
            />)
  
          return (
            <Card key={condition} className={classes.priceCard}>
              <CardContent>
                  <Fragment key={condition}>
                  <Typography variant={'h6'}> <strong>{`${this.makeLabel(condition)}:`}</strong></Typography>
                  <Grid
                  container
                  alignItems={'flex-start'}
                  direction={'row'}
                  justify={'flex-start'}
                  >
                        {levels[0]} 
                  </Grid> 
                  <Grid
                  container
                  alignItems={'flex-start'}
                  direction={'row'}
                  justify={'flex-start'}
                  >
                
                    <div className={classes.description }>
                    <Typography color={'inherit'} > Price Levels 0 - 4 - Over 18 and Under 62</Typography>
                    </div>
      
               
                  </Grid> 
                  <Grid
                  container
                  alignItems={'flex-start'}
                  direction={'row'}
                  justify={'flex-start'}
                  >
                      {levels.slice(1,6)} 
                  </Grid> 
                  <Grid
                  container
                  alignItems={'flex-start'}
                  direction={'row'}
                  justify={'flex-start'}
                  >
                 
                  <div className={classes.description }>
                      <Typography color={'inherit'}> Price Levels 5 - 9 - Under 18 or Over 62</Typography>
                  </div>
          
                  </Grid> 
                  
                  <Grid
                  container
                  alignItems={'flex-start'}
                  direction={'row'}
                  justify={'flex-start'}
                  >
                    {levels.slice(6,11)}
                  </Grid> 
                  </Fragment>      
                </CardContent>
              </Card>
          )
       
    })
  }
  render() {
    const { classes, qualifier, contact, openPLModal } = this.props

    return (
        <Paper style={{border: qualifier === 'standard' ? '2px solid #00FEE6' : '2px solid #1F2833',}} className={classes.paper}>
             <Button className={classes.title} color="primary" onClick={openPLModal}>
        Click To View Poverty Level Descriptions
      </Button>
        <Typography style={{marginBottom: 20}} variant="h5"> {`Step 5: ${this.makeLabel(qualifier)} / ${this.makeLabel(contact)} Price Levels`}</Typography>
          {this.makeConditionRows()}
        </Paper>
    );
  }
}

PriceLevels.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PriceLevels);


// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/ManageCampaign/Options/Filters/Tiered/Filters/PriceLevels.js